import React, { useEffect, useRef, useState } from "react";
import BPCLAvailability from "../../../components/BPCL/BPCLavailability/BPCLavailability";
import BPCLGeneration from "../../../components/BPCL/BPCLGeneration/BPCLGeneration";
import BPCLWeathers from "../../../components/BPCL/BPCLWeathers/BPCLWeathers";
import BPCLInverters from "../../../components/BPCL/BPCLInverters/BPCLInverters";
import { Grid, Box, Typography } from "@mui/material";
import "../../../container/BPCL/BPCL-ProcessDashboard/BPCL-ProcessDashboard.css";
import {
  getHikemmREPlantDashboardGeneration,
  getHikemmREPlantDashboardGenerationBox,
  getHikemmREPlantDashboardInverter,
  getHikemmREPlantDashboardDateWiseInverter,
  getPlantProcessDashboardCo2Data,
  getPlantProcessDashboardCostSavingData,
  getPlantProcessDashboardPlantPeak,
  getPlantProcessDashboardWeatherGraphData,
  getPlantProcessDashboardWeatherPeakData,
  getHikemmREPlantDashboardDateWiseGeneration,
  hikemmREPlantDashboardGenerationCurrent,
} from "../services";
import { useNavigate, useParams } from "react-router-dom";
import BPCLCost from "../../../components/BPCL/BPCL-Cost/BPCLCost";

import { useSelector } from "react-redux";
import { SoftTagFormula } from "../../SmartTag/softTag/SoftTagFormula";
import OverViewMachineMqttData from "../../SmartTag/MachineDashboard/mqttDataMachineDashboard/BpclmqttData";
import { evaluate } from "mathjs";
import { getReportLineChartData } from "../../VMS/VmsCompanyDashboard/VmsMachine/Reports/getReportLineChartData";
import { getReportLineChart } from "../../VMS/VmsCompanyDashboard/VmsMachine/service";
import dayjs from "dayjs";
import Loader from "../../../components/Loader/Loader";

const BPCL_PLANT_TAGS = {
  56: {
    activePower: 5173,
    reactivePower: 5174,
    generation: 5184,
    pr: 5182,
    cuf: 5186,
    gti: 5207,
    ghi: 5204,
    windSpeed: 5210,
    windDirection: 5209,
    ambientTemp: 5203,
    moduleTemp: 5206,
    acPower: 5202,
    plantAvailability: 5172,
    gridAvailability: 5170,
    plantRunHrs: 5175,
    gridAvailabilityHrs: 1,
    dcTags: [7116],
    transformerTags: [1, 1, 1, 5114, 5115, 5113, 5112],
    inverterTags: [
      4793, 4798, 4803, 4808, 4813, 4818, 4823, 4828, 4833, 4838, 4843,
      4848, 4853, 4858, 4863, 4868, 4878, 4883, 4888, 4893, 4898, 4903,
      4908, 4913, 4918, 4923, 5195, 4933, 4938, 4943, 4948, 4953, 4558,
      4563, 4568, 4573, 4578, 4583, 4588, 4593, 4598, 4603, 4608, 4617,
      4622, 4627, 4632, 4637, 4647, 4652, 4657, 4662, 4667, 4672, 4677,
      4682, 4687, 4692, 4697, 4702, 4707, 4712, 4958,
    ],
    costSaving: 6503,
    co2: 6504,
  },
  57: {
    activePower: 6409,
    reactivePower: 6398,
    generation: 6407,
    pr: 6412,
    cuf: 6411,
    gti: 6393,
    ghi: 6381,
    windSpeed: 6388,
    windDirection: 6387,
    ambientTemp: 6385,
    moduleTemp: 6383,
    acPower: 6483,
    plantAvailability: 1,
    gridAvailability: 1,
    plantRunHrs: 1,
    gridAvailabilityHrs: 1,
    dcTags: [7117],
    transformerTags: [1, 1, 1, 6414, 6415, 1, 6413],
    inverterTags: [
      6276, 6281, 6286, 6291, 6301, 6306, 6311, 6316, 6321, 6326, 6331,
      6336, 6341, 6346, 6351, 6356, 6361, 6366, 6371, 6376, 6296,
    ],
    costSaving: 6501,
    co2: 6502,
  },
  58: {
    activePower: 5375,
    reactivePower: 5389,
    generation: 5381,
    pr: 5430,
    cuf: 5429,
    gti: 5447,
    ghi: 5451,
    windSpeed: 5457,
    windDirection: 5456,
    ambientTemp: 5458,
    moduleTemp: 5459,
    acPower: 5375,
    plantAvailability: 5412,
    gridAvailability: 5444,
    plantRunHrs: 5423,
    gridAvailabilityHrs: 5415,
    dcTags: [
      4244, 4265, 4286, 4307, 4328, 4349, 4370, 4391, 4412, 4433, 4538,
      4454, 4475, 4496, 4517,
    ],
    transformerTags: [1, 1, 1, 5448, 5449, 1, 5410],
    inverterTags: [
      4257, 4278, 4299, 4320, 4341, 4362, 4383, 4404, 4425, 4446, 4551,
      4467, 4488, 4509, 4530,
    ],
    costSaving: 6507,
    co2: 6508,
  },
  59: {
    activePower: 5830,
    reactivePower: 5844,
    generation: 5836,
    pr: 5885,
    cuf: 5884,
    gti: 5918,
    ghi: 5906,
    windSpeed: 5912,
    windDirection: 5911,
    ambientTemp: 5913,
    moduleTemp: 5914,
    acPower: 5830,
    plantAvailability: 5867,
    gridAvailability: 5899,
    plantRunHrs: 5878,
    gridAvailabilityHrs: 5870,
    dcTags: [
      5923, 5944, 5965, 5986, 6007, 6028, 6049, 6070, 6091, 6112, 6133,
      6154, 6175, 6196, 6217, 6238, 6259,
    ],
    transformerTags: [1, 1, 1, 5903, 5904, 1, 5865],
    inverterTags: [
      5936, 5957, 5978, 5999, 6020, 6041, 6062, 6083, 6104, 6125, 6146,
      6167, 6188, 6209, 6230, 6251, 6272,
    ],
    costSaving: 6505,
    co2: 6506,
  },
  138: {
    activePower: 10078,
    reactivePower: 10079,
    generation: 10092,
    pr: 10073,
    cuf: 10074,
    gti: 10061,
    ghi: 10060,
    windSpeed: 10065,
    windDirection: 10066,
    ambientTemp: 10062,
    moduleTemp: 10063,
    acPower: 10078,
    plantAvailability: 10088,
    gridAvailability: 10089,
    plantRunHrs: 10090,
    gridAvailabilityHrs: 10079,
    dcTags: [10094],
    transformerTags: [1, 1, 1, 10084, 10085, 10093, 10086],
    inverterTags: [
      10117, 10140, 10163, 10186, 10209, 10232, 10255, 10278, 10301, 10324,
      10347, 10370, 10393, 10416, 10439, 10462,
    ],
    costSaving: 10463,
    co2: 10464,
  },
};

const BPCLProcessDashboard = () => {
  const [plantPeakData, setPlantPeakData] = useState([]);
  const [plantPeakDateWiseData, setPlantPeakDateWiseData] = useState([]);

  const param = useParams();
  const [dateRange, setDateRange] = React.useState(1);
  const [generationTime, setGenerationTime] = React.useState(1);
  const [generationValue, setGenerationValue] = React.useState(1);
  const [generationData, setGenerationData] = useState([]);
  const [generationDateWiseData, setGenerationDateWiseData] = useState([]);
  const [generationBoxData, setGenartionBoxData] = useState({});
  const [generationCurrentData, setGenartionCurrentData] = useState({});
  const [weatherTime, setWeatherTime] = useState(1);
  const [weatherValue, setWeatherValue] = useState(2);
  const [weatherGraphData, setWeatherGraphData] = useState([]);
  const [weatherGraphDateWiseData, setWeatherGraphDateWiseData] = useState([]);
  const [inverterData, setInverterData] = useState([]);
  const [inverterDateWiseData, setInverterDateWiseData] = useState([]);
  const [inverterTime, setInverterTime] = useState(1);
  const [costData, setCostData] = useState([]);
  const [costDateWiseData, setCostDateWiseData] = useState([]);
  const [costTime, setCostTime] = useState(1);
  const [co2Data, setCo2Data] = useState([]);
  const [co2DateWiseData, setCo2DateWiseData] = useState([]);
  const [co2Time, setCo2Time] = useState(1);
  const [mqttTagData, setMqttTagData] = useState([]);
  const [topics, setTopics] = useState([]);
  const [realTimeData, setRealTimeData] = useState([]);
  const [mqttTagPreviousvalue, setMqttTagPreviousvalue] = useState([]);
  const [tagStatus, setTagStatus] = useState([]);
  const [sliderRealTimeTagData, setSliderRealTimeTagData] = useState([]);
  const [tagListDataGroupAndList, setTagListDataGroupAndList] = useState([]);
  const [previousValues, setPreviousValues] = useState({});
  const [availabilityPiechart, setAvailabilityPiechart] = useState([]);
  const [weatherRealTime, setWeatherRealTime] = useState([]);
  const [weatherRealData, setWeatherRealData] = useState([]);
  const [inverterRealTimeData, setInverterRealTimeData] = useState([]);
  const [costStartDate, setCostStartDate] = useState(null);
  const [costEndDate, setCostEndDate] = useState(null);
  const [co2StartDate, setCo2StartDate] = useState(null);
  const [co2EndDate, setCo2EndDate] = useState(null);
  const [availabilityStartDate, setAvailabilityStartDate] = useState(null);
  const [availabilityEndDate, setAvailabilityEndDate] = useState(null);
  const [inverterStartDate, setInverterStartDate] = useState(null);
  const [inverterEndDate, setInverterEndDate] = useState(null);
  const [generationStartDate, setGenerationStartDate] = useState(null);
  const [generationEndDate, setGenerationEndDate] = useState(null);
  const [weatherStartDate, setWeatherStartDate] = useState(null);
  const [weatherEndDate, setWeatherEndDate] = useState(null);
  // In your parent component where InverterDatepicker is used
  const [multiAxisWeatherStartDate, setMultiAxisWeatherStartDate] =
    useState(null);
  const [multiAxisWeatherEndDate, setMultiAxisWeatherEndDate] = useState(null);
  const [linechartData, setLinechartData] = useState([]);
  const [linechartData1, setLinechartData1] = useState([]);
  const [acValue, setAcValue] = useState([]);
  const [DCValues, setDCValues] = useState([]);
  const [selectTimeRange, setSelectTimeRange] = useState("1");
  const [isLoading, setIsLoading] = useState(false);
const isFirstRender = useRef(true);
  const plantTags = BPCL_PLANT_TAGS[param.id] || {};
  const tagId = (name) => plantTags[name] || 1;
  const tagIds = (name) => plantTags[name] || [1];

  useEffect(() => {
    setMultiAxisWeatherStartDate(dayjs().format("YYYY-MM-DD"));
    setMultiAxisWeatherEndDate(dayjs().format("YYYY-MM-DD"));
  }, []);

  const { selectTimeZoneProfile, is_renewable_energy } = useSelector(
    (state) => state.userState
  );

  const mergedArray = mqttTagData
    ? [].concat(...Object.values(mqttTagData))
    : [];

  const mqttDataReduce = sliderRealTimeTagData.reduce((map, item) => {
    map[item.device_tag] = Number(item.tagValue);
    return map;
  }, {});

  let tagValue = mergedArray.length
    ? mergedArray.find(
        (f) =>
          f.device__uid === availabilityPiechart[0]?.device_uid &&
          f.device_tag === availabilityPiechart[0]?.device_tag
      )?.["tagValue"] || 0.0
    : 0.0;
  let tagValue1 = mergedArray.length
    ? mergedArray.find(
        (f) =>
          f.device__uid === availabilityPiechart[1]?.device_uid &&
          f.device_tag === availabilityPiechart[1]?.device_tag
      )?.["tagValue"] || 0.0
    : 0.0;
  let tagValue2 = mergedArray.length
    ? mergedArray.find(
        (f) =>
          f.device__uid === availabilityPiechart[2]?.device_uid &&
          f.device_tag === availabilityPiechart[2]?.device_tag
      )?.["tagValue"] || 0.0
    : 0.0;
  let tagValue3 = mergedArray.length
    ? mergedArray.find(
        (f) =>
          f.device__uid === availabilityPiechart[3]?.device_uid &&
          f.device_tag === availabilityPiechart[3]?.device_tag
      )?.["tagValue"] || 0.0
    : 0.0;

  console.log(
    "tagValuetagValuetagValuetagValuetagValue",
    sliderRealTimeTagData,
    availabilityPiechart[0]?.device_uid,
    availabilityPiechart[0]?.device_tag
  );
  useEffect(() => {
    if (mqttTagPreviousvalue.length) {
      const averagCalTagvalue = mqttTagPreviousvalue.map((row) => {
        // Handle soft tags
        if (row.is_soft_tag && row.soft_tag_id__formula) {
          // Compute current value using the formula
          const evaluatedCurrentValue = SoftTagFormula(
            row.soft_tag_id__formula,
            mqttDataReduce
          )?.value;
          console.log("Evaluated current value:", evaluatedCurrentValue);

          // Set the evaluated value as the new previous value
          setPreviousValues((prev) => ({
            ...prev,
            [row.soft_tag_id__formula]: evaluatedCurrentValue,
          }));

          // Use the previous value from state
          const evaluatedPreviousValue =
            previousValues[row.soft_tag_id__formula] || 0;
          console.log("Evaluated previous value:", evaluatedPreviousValue);
          console.log(
            "evaluatedCurrentValue",
            evaluatedCurrentValue,
            evaluatedPreviousValue
          );

          const statusValue =
            evaluatedPreviousValue !== 0
              ? ((evaluatedCurrentValue - evaluatedPreviousValue) /
                  evaluatedPreviousValue) *
                100
              : 0;

          console.log(
            "evaluatedCurrentValue",
            evaluatedCurrentValue,
            evaluatedPreviousValue,
            statusValue
          );

          return {
            dvName: row.dvName,
            statusValue: statusValue,
            formula: row.soft_tag_id__formula,
          };
        } else {
          const avgCal = ((row.curValue - row.prevValue) / row.prevValue) * 100;

          return {
            dvName: row.dvName,
            statusValue: isFinite(avgCal) ? avgCal : 0.0,
          };
        }
      });

      setTagStatus(averagCalTagvalue);
    }
  }, [mqttTagPreviousvalue]);

  const mergeTopics = (existingTopics, newTopics) => {
    return Array.from(new Set([...existingTopics, ...newTopics]));
  };

  useEffect(() => {
    if (realTimeData.length) {
      const topicArray = realTimeData.map(
        (e) => "Hikar/DeviceUID/" + e.device_uid
      );
      // console.log("topicArray", topicArray);
      // setTopics(topicArray);
      setTopics((prevTopics) => mergeTopics(prevTopics, topicArray));
    }
  }, [realTimeData]);

  useEffect(() => {
    if (DCValues.length) {
      const topicArray = DCValues.map((e) => "Hikar/DeviceUID/" + e.device_uid);
      // console.log("topicArray", topicArray);
      // setTopics(topicArray);
      setTopics((prevTopics) => mergeTopics(prevTopics, topicArray));
    }
  }, [DCValues]);

  useEffect(() => {
    if (acValue.length) {
      const topicArray = acValue.map((e) => "Hikar/DeviceUID/" + e.device_uid);
      // console.log("topicArray", topicArray);
      // setTopics(topicArray);
      setTopics((prevTopics) => mergeTopics(prevTopics, topicArray));
    }
  }, [acValue]);

  console.log("weatherRealTime", weatherRealTime);

  useEffect(() => {
    if (weatherRealTime.length) {
      const topicArray = weatherRealTime.map(
        (e) => "Hikar/DeviceUID/" + e.device_uid
      );
      // console.log("topicArray", topicArray);
      // setTopics(topicArray);
      setTopics((prevTopics) => mergeTopics(prevTopics, topicArray));
    }
  }, [weatherRealTime]);

  useEffect(() => {
    if (weatherRealData.length) {
      const topicArray = weatherRealData.map(
        (e) => "Hikar/DeviceUID/" + e.device_uid
      );
      // console.log("topicArray", topicArray);
      // setTopics(topicArray);
      setTopics((prevTopics) => mergeTopics(prevTopics, topicArray));
    }
  }, [weatherRealData]);

  useEffect(() => {
    if (inverterRealTimeData.length) {
      const topicArray = inverterRealTimeData.map(
        (e) => "Hikar/DeviceUID/" + e.device_uid
      );
      // console.log("topicArray", topicArray);
      // setTopics(topicArray);
      setTopics((prevTopics) => mergeTopics(prevTopics, topicArray));
    }
  }, [inverterRealTimeData]);

  useEffect(() => {
    if (availabilityPiechart.length) {
      const topicArray = availabilityPiechart.map(
        (e) => "Hikar/DeviceUID/" + e.device_uid
      );
      // console.log("topicArray", topicArray);
      // setTopics(topicArray);
      setTopics((prevTopics) => mergeTopics(prevTopics, topicArray));
    }
  }, [availabilityPiechart]);

  const getTagDateAndTime = () => {
    return new Date().toLocaleString("en-US", {
      timeZone: selectTimeZoneProfile || "UTC",
      hour12: false,
    });
  };

  useEffect(() => {
    handleGenerationRealTimeData(); // Call it immediately on mount

    // Set up interval to call handleRealTimeData every 1 minute
    const intervalId = setInterval(() => {
      handleGenerationRealTimeData();
    }, 60000); // 60000 milliseconds = 1 minute

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    handlePieRealTimeData(); // Call it immediately on mount

    // Set up interval to call handleRealTimeData every 1 minute
    const intervalId = setInterval(() => {
      handlePieRealTimeData();
    }, 60000); // 60000 milliseconds = 1 minute

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    handleWeatherRealTimeData(); // Call it immediately on mount

    // Set up interval to call handleRealTimeData every 1 minute
    // const intervalId = setInterval(() => {
    //   handleWeatherRealTimeData();
    // }, 60000); // 60000 milliseconds = 1 minute

    // // Clean up the interval on component unmount
    // return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    handleAcRealTimeValue();
  }, []);

  useEffect(() => {
    handleWeatherspeedometerRealTimeData(); // Call it immediately on mount

    // Set up interval to call handleRealTimeData every 1 minute
    const intervalId = setInterval(() => {
      handleWeatherspeedometerRealTimeData();
    }, 60000); // 60000 milliseconds = 1 minute

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    handleInverterRealTimeData(); // Call it immediately on mount

    // Set up interval to call handleRealTimeData every 1 minute
    const intervalId = setInterval(() => {
      handleInverterRealTimeData();
    }, 60000); // 60000 milliseconds = 1 minute

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const handleGenerationRealTimeData = async () => {
    const params = {
      plant_id: param.id,
      weather_tags: [
        tagId("activePower"),
        tagId("reactivePower"),
        tagId("cuf"),
        tagId("pr"),
      ],
    };
    try {
      const resp = await getPlantProcessDashboardWeatherPeakData(params);
      if (resp.status === 200 || resp.status === 201) {
        const tagsData = resp.data.payload;
        setRealTimeData(tagsData);

        const tagDataList = tagsData.map((e) => {
          const obj = {
            dvName: e.device_tag || "-",
            tagName: e.tag_name,
            machineUID: e.device_uid,
            is_soft_tag: e.is_soft_tag || false,
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        // Combine default and calculated tags if needed
        setTagListDataGroupAndList(tagDataList);

        // Evaluate formula if it’s a soft tag
        const evaluateSoftTagValue = (formula, tags) => {
          try {
            const tagPattern = /[A-Za-z0-9_]+/g;
            const tagMatches = formula.match(tagPattern) || [];
            // let evaluatedFormula = formula;
            let variables = {};

            // Replace tags in formula with current values from tags list
            tagMatches.forEach((tag) => {
              const foundTag = tags.find((t) => t.dvName === tag);
              const tagValue = foundTag ? parseFloat(foundTag.curValue) : 0;
              // evaluatedFormula = evaluatedFormula.replace(tag, tagValue);
              variables[tag] = foundTag ? parseFloat(foundTag.curValue) : 0;
            });
            // console.log("evaluatedFormula", evaluatedFormula);
            // return eval(evaluatedFormula);
            return evaluate(formula, variables);
          } catch {
            return 0; // Default to 0 on error
          }
        };

        const tagObj = tagsData.map((e) => {
          let curValue = 0;
          let prevValue = 0;

          if (e.is_soft_tag && e.soft_tag_id__formula) {
            curValue = evaluateSoftTagValue(
              e.soft_tag_id__formula,
              mqttTagPreviousvalue
            );
            prevValue = curValue;
          }

          const obj = {
            is_soft_tag: e.is_soft_tag,
            dvName: e.device_tag || "-",
            prevValue,
            curValue,
            dateAndTime: getTagDateAndTime(),
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        setMqttTagPreviousvalue(tagObj);
      }
    } catch (error) {
      console.log("Error in handleRealTimeData:", error);
    }
  };

  const handlePieRealTimeData = async () => {
    const params = {
      plant_id: param.id,
      weather_tags: [
        tagId("plantAvailability"),
        tagId("gridAvailability"),
        tagId("plantRunHrs"),
        tagId("gridAvailabilityHrs"),
      ],
    };
    try {
      const resp = await getPlantProcessDashboardWeatherPeakData(params);
      if (resp.status === 200 || resp.status === 201) {
        const tagsData = resp.data.payload;
        setAvailabilityPiechart(tagsData);
        // setRealTimeData(tagsData);

        const tagDataList = tagsData.map((e) => {
          const obj = {
            dvName: e.device_tag || "-",
            tagName: e.tag_name,
            machineUID: e.device_uid,
            is_soft_tag: e.is_soft_tag || false,
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        // Combine default and calculated tags if needed
        setTagListDataGroupAndList(tagDataList);

        // Evaluate formula if it’s a soft tag
        const evaluateSoftTagValue = (formula, tags) => {
          try {
            const tagPattern = /[A-Za-z0-9_]+/g;
            const tagMatches = formula.match(tagPattern) || [];
            // let evaluatedFormula = formula;
            let variables = {};

            // Replace tags in formula with current values from tags list
            tagMatches.forEach((tag) => {
              const foundTag = tags.find((t) => t.dvName === tag);
              const tagValue = foundTag ? parseFloat(foundTag.curValue) : 0;
              // evaluatedFormula = evaluatedFormula.replace(tag, tagValue);
              variables[tag] = foundTag ? parseFloat(foundTag.curValue) : 0;
            });
            // console.log("evaluatedFormula", evaluatedFormula);
            // return eval(evaluatedFormula);
            return evaluate(formula, variables);
          } catch {
            return 0; // Default to 0 on error
          }
        };

        const tagObj = tagsData.map((e) => {
          let curValue = 0;
          let prevValue = 0;

          if (e.is_soft_tag && e.soft_tag_id__formula) {
            curValue = evaluateSoftTagValue(
              e.soft_tag_id__formula,
              mqttTagPreviousvalue
            );
            prevValue = curValue;
          }

          const obj = {
            is_soft_tag: e.is_soft_tag,
            dvName: e.device_tag || "-",
            prevValue,
            curValue,
            dateAndTime: getTagDateAndTime(),
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        setMqttTagPreviousvalue(tagObj);
      }
    } catch (error) {
      console.log("Error in handleRealTimeData:", error);
    }
  };

  const handleGenerationDCValue = async () => {
    const params = {
      plant_id: param.id,
      weather_tags: tagIds("dcTags"),
    };
    try {
      const resp = await getPlantProcessDashboardWeatherPeakData(params);
      if (resp.status === 200 || resp.status === 201) {
        const tagsData = resp.data.payload;
        setDCValues(tagsData);

        const tagDataList = tagsData.map((e) => {
          const obj = {
            dvName: e.device_tag || "-",
            tagName: e.tag_name,
            machineUID: e.device_uid,
            is_soft_tag: e.is_soft_tag || false,
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        // Combine default and calculated tags if needed
        setTagListDataGroupAndList(tagDataList);

        // Evaluate formula if it’s a soft tag
        const evaluateSoftTagValue = (formula, tags) => {
          try {
            const tagPattern = /[A-Za-z0-9_]+/g;
            const tagMatches = formula.match(tagPattern) || [];
            // let evaluatedFormula = formula;
            let variables = {};

            // Replace tags in formula with current values from tags list
            tagMatches.forEach((tag) => {
              const foundTag = tags.find((t) => t.dvName === tag);
              const tagValue = foundTag ? parseFloat(foundTag.curValue) : 0;
              // evaluatedFormula = evaluatedFormula.replace(tag, tagValue);
              variables[tag] = foundTag ? parseFloat(foundTag.curValue) : 0;
            });
            // console.log("evaluatedFormula", evaluatedFormula);
            // return eval(evaluatedFormula);
            return evaluate(formula, variables);
          } catch {
            return 0; // Default to 0 on error
          }
        };

        const tagObj = tagsData.map((e) => {
          let curValue = 0;
          let prevValue = 0;

          if (e.is_soft_tag && e.soft_tag_id__formula) {
            curValue = evaluateSoftTagValue(
              e.soft_tag_id__formula,
              mqttTagPreviousvalue
            );
            prevValue = curValue;
          }

          const obj = {
            is_soft_tag: e.is_soft_tag,
            dvName: e.device_tag || "-",
            prevValue,
            curValue,
            dateAndTime: getTagDateAndTime(),
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        setMqttTagPreviousvalue(tagObj);
      }
    } catch (error) {
      console.log("Error in handleRealTimeData:", error);
    }
  };

  useEffect(() => {
    handleGenerationDCValue(); // Call it immediately on mount

    // Set up interval to call handleRealTimeData every 1 minute
    const intervalId = setInterval(() => {
      handleGenerationDCValue();
    }, 60000); // 60000 milliseconds = 1 minute

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const handleAcRealTimeValue = async () => {
    const params = {
      plant_id: param.id,
      weather_tags: [tagId("acPower")],
    };
    try {
      const resp = await getPlantProcessDashboardWeatherPeakData(params);
      if (resp.status === 200 || resp.status === 201) {
        const tagsData = resp.data.payload;
        setAcValue(tagsData);

        const tagDataList = tagsData.map((e) => {
          const obj = {
            dvName: e.device_tag || "-",
            tagName: e.tag_name,
            machineUID: e.device_uid,
            is_soft_tag: e.is_soft_tag || false,
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        // Combine default and calculated tags if needed
        setTagListDataGroupAndList(tagDataList);

        // Evaluate formula if it’s a soft tag
        const evaluateSoftTagValue = (formula, tags) => {
          try {
            const tagPattern = /[A-Za-z0-9_]+/g;
            const tagMatches = formula.match(tagPattern) || [];
            // let evaluatedFormula = formula;
            let variables = {};

            // Replace tags in formula with current values from tags list
            tagMatches.forEach((tag) => {
              const foundTag = tags.find((t) => t.dvName === tag);
              const tagValue = foundTag ? parseFloat(foundTag.curValue) : 0;
              // evaluatedFormula = evaluatedFormula.replace(tag, tagValue);
              variables[tag] = foundTag ? parseFloat(foundTag.curValue) : 0;
            });
            // console.log("evaluatedFormula", evaluatedFormula);
            // return eval(evaluatedFormula);
            return evaluate(formula, variables);
          } catch {
            return 0; // Default to 0 on error
          }
        };

        const tagObj = tagsData.map((e) => {
          let curValue = 0;
          let prevValue = 0;

          if (e.is_soft_tag && e.soft_tag_id__formula) {
            curValue = evaluateSoftTagValue(
              e.soft_tag_id__formula,
              mqttTagPreviousvalue
            );
            prevValue = curValue;
          }

          const obj = {
            is_soft_tag: e.is_soft_tag,
            dvName: e.device_tag || "-",
            prevValue,
            curValue,
            dateAndTime: getTagDateAndTime(),
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        setMqttTagPreviousvalue(tagObj);
      }
    } catch (error) {
      console.log("Error in handleRealTimeData:", error);
    }
  };

  const handleWeatherRealTimeData = async () => {
    const params = {
      plant_id: param.id,
      weather_tags: [tagId("activePower"), tagId("gti")],
    };
    try {
      const resp = await getPlantProcessDashboardWeatherPeakData(params);
      if (resp.status === 200 || resp.status === 201) {
        const tagsData = resp.data.payload;
        setWeatherRealTime(tagsData);
        // setRealTimeData(tagsData);
        const tagDataList = tagsData.map((e) => {
          const obj = {
            dvName: e.device_tag || "-",
            tagName: e.tag_name,
            machineUID: e.device_uid,
            is_soft_tag: e.is_soft_tag || false,
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        // Combine default and calculated tags if needed
        setTagListDataGroupAndList(tagDataList);

        // Evaluate formula if it’s a soft tag
        const evaluateSoftTagValue = (formula, tags) => {
          try {
            const tagPattern = /[A-Za-z0-9_]+/g;
            const tagMatches = formula.match(tagPattern) || [];
            // let evaluatedFormula = formula;
            let variables = {};

            // Replace tags in formula with current values from tags list
            tagMatches.forEach((tag) => {
              const foundTag = tags.find((t) => t.dvName === tag);
              const tagValue = foundTag ? parseFloat(foundTag.curValue) : 0;
              // evaluatedFormula = evaluatedFormula.replace(tag, tagValue);
              variables[tag] = foundTag ? parseFloat(foundTag.curValue) : 0;
            });
            // console.log("evaluatedFormula", evaluatedFormula);
            // return eval(evaluatedFormula);
            return evaluate(formula, variables);
          } catch {
            return 0; // Default to 0 on error
          }
        };

        const tagObj = tagsData.map((e) => {
          let curValue = 0;
          let prevValue = 0;

          if (e.is_soft_tag && e.soft_tag_id__formula) {
            curValue = evaluateSoftTagValue(
              e.soft_tag_id__formula,
              mqttTagPreviousvalue
            );
            prevValue = curValue;
          }

          const obj = {
            is_soft_tag: e.is_soft_tag,
            dvName: e.device_tag || "-",
            prevValue,
            curValue,
            dateAndTime: getTagDateAndTime(),
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        setMqttTagPreviousvalue(tagObj);
      }
    } catch (error) {
      console.log("Error in handleRealTimeData:", error);
    }
  };
  const handleWeatherspeedometerRealTimeData = async () => {
    const params = {
      plant_id: param.id,
      weather_tags: [
        tagId("gti"),
        tagId("windSpeed"),
        tagId("ambientTemp"),
        tagId("ghi"),
        tagId("windDirection"),
        tagId("moduleTemp"),
      ],
    };
    try {
      const resp = await getPlantProcessDashboardWeatherPeakData(params);
      if (resp.status === 200 || resp.status === 201) {
        const tagsData = resp.data.payload;
        setWeatherRealData(tagsData);
        // setRealTimeData(tagsData);

        const tagDataList = tagsData.map((e) => {
          const obj = {
            dvName: e.device_tag || "-",
            tagName: e.tag_name,
            machineUID: e.device_uid,
            is_soft_tag: e.is_soft_tag || false,
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        // Combine default and calculated tags if needed
        setTagListDataGroupAndList(tagDataList);

        // Evaluate formula if it’s a soft tag
        const evaluateSoftTagValue = (formula, tags) => {
          try {
            const tagPattern = /[A-Za-z0-9_]+/g;
            const tagMatches = formula.match(tagPattern) || [];
            // let evaluatedFormula = formula;
            let variables = {};

            // Replace tags in formula with current values from tags list
            tagMatches.forEach((tag) => {
              const foundTag = tags.find((t) => t.dvName === tag);
              const tagValue = foundTag ? parseFloat(foundTag.curValue) : 0;
              // evaluatedFormula = evaluatedFormula.replace(tag, tagValue);
              variables[tag] = foundTag ? parseFloat(foundTag.curValue) : 0;
            });
            // console.log("evaluatedFormula", evaluatedFormula);
            // return eval(evaluatedFormula);
            return evaluate(formula, variables);
          } catch {
            return 0; // Default to 0 on error
          }
        };

        const tagObj = tagsData.map((e) => {
          let curValue = 0;
          let prevValue = 0;

          if (e.is_soft_tag && e.soft_tag_id__formula) {
            curValue = evaluateSoftTagValue(
              e.soft_tag_id__formula,
              mqttTagPreviousvalue
            );
            prevValue = curValue;
          }

          const obj = {
            is_soft_tag: e.is_soft_tag,
            dvName: e.device_tag || "-",
            prevValue,
            curValue,
            dateAndTime: getTagDateAndTime(),
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        setMqttTagPreviousvalue(tagObj);
      }
    } catch (error) {
      console.log("Error in handleRealTimeData:", error);
    }
  };

  const handleInverterRealTimeData = async () => {
    const params = {
      plant_id: param.id,
      weather_tags: tagIds("transformerTags"),
    };
    try {
      const resp = await getPlantProcessDashboardWeatherPeakData(params);
      if (resp.status === 200 || resp.status === 201) {
        const tagsData = resp.data.payload;
        setInverterRealTimeData(tagsData);
        // setRealTimeData(tagsData);

        const tagDataList = tagsData.map((e) => {
          const obj = {
            dvName: e.device_tag || "-",
            tagName: e.tag_name,
            machineUID: e.device_uid,
            is_soft_tag: e.is_soft_tag || false,
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        // Combine default and calculated tags if needed
        setTagListDataGroupAndList(tagDataList);

        // Evaluate formula if it’s a soft tag
        const evaluateSoftTagValue = (formula, tags) => {
          try {
            const tagPattern = /[A-Za-z0-9_]+/g;
            const tagMatches = formula.match(tagPattern) || [];
            // let evaluatedFormula = formula;
            let variables = {};

            // Replace tags in formula with current values from tags list
            tagMatches.forEach((tag) => {
              const foundTag = tags.find((t) => t.dvName === tag);
              const tagValue = foundTag ? parseFloat(foundTag.curValue) : 0;
              // evaluatedFormula = evaluatedFormula.replace(tag, tagValue);
              variables[tag] = foundTag ? parseFloat(foundTag.curValue) : 0;
            });
            // console.log("evaluatedFormula", evaluatedFormula);
            // return eval(evaluatedFormula);
            return evaluate(formula, variables);
          } catch {
            return 0; // Default to 0 on error
          }
        };

        const tagObj = tagsData.map((e) => {
          let curValue = 0;
          let prevValue = 0;

          if (e.is_soft_tag && e.soft_tag_id__formula) {
            curValue = evaluateSoftTagValue(
              e.soft_tag_id__formula,
              mqttTagPreviousvalue
            );
            prevValue = curValue;
          }

          const obj = {
            is_soft_tag: e.is_soft_tag,
            dvName: e.device_tag || "-",
            prevValue,
            curValue,
            dateAndTime: getTagDateAndTime(),
            soft_tag_id__formula: e.soft_tag_id__formula,
          };
          return obj;
        });

        setMqttTagPreviousvalue(tagObj);
      }
    } catch (error) {
      console.log("Error in handleRealTimeData:", error);
    }
  };

  const handleDateCo2Time = (event) => {
    setCo2Time(event.target.value);
  };

  const handleDateCostTime = (event) => {
    setCostTime(event.target.value);
  };
  const handleDateInverterTime = (event) => {
    setInverterTime(event.target.value);
  };

  const handleDateWeatherTime = (event) => {
    setWeatherTime(event.target.value);
  };
  const handleDateWeatherValue = (event) => {
    setWeatherValue(event.target.value);
  };

  const handleDateGenerationTime = (event) => {
    setGenerationTime(event.target.value);
  };
  const handleDateGenerationValue = (event) => {
    setGenerationValue(event.target.value);
  };

  const handleDateRangeChange = (event) => {
    setDateRange(event.target.value);
  };

  useEffect(() => {
    if (availabilityStartDate && availabilityEndDate) {
      handlePlantPeakDataDateWise();
    }
  }, [availabilityStartDate, availabilityEndDate]);

  useEffect(() => {
    handlePlantPeakData();
  }, [dateRange]);

  const handlePlantPeakDataDateWise = async () => {
    const params = {
      plant_id: param.id,
      peak_tags: tagId("activePower"),
      peak_tilt_tags: tagId("gti"),
      start_date: `${availabilityStartDate} 00:00:00`,
      end_date: `${availabilityEndDate} 23:59:59`,
    };
    try {
      setIsLoading(true);
      const resp = await getPlantProcessDashboardPlantPeak(params);
      if (resp.status == 200 || resp.status == 201) {
        setPlantPeakDateWiseData(resp.data.payload);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("handlesubmit", error);
    }
  };

  const handlePlantPeakData = async () => {
    const params = {
      plant_id: param.id,
      peak_tags: tagId("activePower"),
      peak_tilt_tags: tagId("gti"),
      time_period: dateRange,
    };
    try {
      const resp = await getPlantProcessDashboardPlantPeak(params);
      if (resp.status == 200 || resp.status == 201) {
        setPlantPeakData(resp.data.payload);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  useEffect(() => {
    if (generationValue && generationStartDate && generationEndDate) {
      handleGenerationBarChartDateWise();
    }
  }, [generationValue, generationStartDate, generationEndDate]);

  useEffect(() => {
    handleGenerationGraphData();
    handleGenerationBoxData();
  }, [generationTime, generationValue]);
  // For generationValue change – WITH loader (but skip first render)
useEffect(() => {
  if (isFirstRender.current) {
    isFirstRender.current = false;
    return;
  }

  handleGenerationGraphData(true); // show loader
  handleGenerationBoxData();

}, [generationValue,generationTime]);

  useEffect(() => {
    // Initial API call
    handleGenerationCurrentData();
    handleGenerationBoxData();
    // Set interval for every 10 minutes
    const interval = setInterval(() => {
      handleGenerationCurrentData();
    
    }, 60000); // 600000 ms = 10 minutes

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [generationTime]);

  const handleGenerationBarChartDateWise = async () => {
    const params = {
      plant_id: param.id,
      start_date: `${generationStartDate} 00:00:00`,
      end_date: `${generationEndDate} 23:59:59`,
    };
    if (generationValue == 1) {
      params["generation_tag"] = tagId("generation");
      params["graph_tag"] = 1;
    } else if (generationValue == 2) {
      params["pr_tag"] = tagId("pr");
      params["graph_tag"] = 2;
    } else {
      params["cuf_tag"] = tagId("cuf");
      params["graph_tag"] = 3;
    }

    try {
      const resp = await getHikemmREPlantDashboardDateWiseGeneration(params);
      if (resp.status == 200 || resp.status == 201) {
        setGenerationDateWiseData(resp.data.payload);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  const handleGenerationGraphData = async () => {
    const params = {
      plant_id: param.id,
      time_period: generationTime,
    };
    if (generationValue == 1) {
      params["generation_tag"] = tagId("generation");
      params["graph_tag"] = 1;
    } else if (generationValue == 2) {
      params["pr_tag"] = tagId("pr");
      params["generation_tag"] = tagId("generation");
      params["graph_tag"] = 2;
    } else {
      params["cuf_tag"] = tagId("cuf");
      params["generation_tag"] = tagId("generation");
      params["graph_tag"] = 3;
    }

    try {
    setIsLoading(true);
  
      const resp = await getHikemmREPlantDashboardGeneration(params);
      if (resp.status === 200 || resp.status === 201) {
        setGenerationData(resp.data.payload);
      }
    } catch (error) {
      console.log("handleGenerationGraphData error", error);
    } finally {
       setIsLoading(false);
    }
  };

  const handleGenerationBoxData = async () => {
    const params = {
      plant_id: param.id,
      generation_tag: tagId("generation"),
      pr_tag: tagId("pr"),
      cuf_tag: tagId("cuf"),
      plant_gti_tag: tagId("gti"),
      time_period: generationTime,
    };
    try {
      const resp = await getHikemmREPlantDashboardGenerationBox(params);
      if (resp.status == 200 || resp.status == 201) {
        setGenartionBoxData(resp.data.payload);
      }
    } catch (error) {
      console.log("handlesumit", error);
    }
  };
  const handleGenerationCurrentData = async () => {
    const params = {
      plant_id: param.id,
      generation_tag: tagId("generation"),
      pr_tag: tagId("pr"),
      cuf_tag: tagId("cuf"),
      plant_gti_tag: tagId("gti"),
      time_period: 1,
    };
    try {
      const resp = await hikemmREPlantDashboardGenerationCurrent(params);
      if (resp.status == 200 || resp.status == 201) {
        setGenartionCurrentData(resp.data.payload);
      }
    } catch (error) {
      console.log("handlesumit", error);
    }
  };

  useEffect(() => {
    handleWeatherGraphData();
  }, [weatherTime, weatherValue]);

  useEffect(() => {
    if (weatherValue && weatherStartDate && weatherEndDate) {
      handleWeatherGraphDataDateWise();
    }
  }, [weatherValue, weatherStartDate, weatherEndDate]);

  const handleWeatherGraphDataDateWise = async () => {
    const params = {
      plant_id: param.id,
      gti_tag: tagId("gti"),
      ghi_tag: tagId("ghi"),
      wind_speed_tag: tagId("windSpeed"),
      ambient_temperature_tag: tagId("ambientTemp"),
      module_temperature_tag: tagId("moduleTemp"),
      weather_graph: weatherValue,
      start_date: `${weatherStartDate} 00:00:00`,
      end_date: `${weatherEndDate} 23:59:59`,
    };
    try {
      const resp = await getPlantProcessDashboardWeatherGraphData(params);
      if (resp.status == 200 || resp.status == 201) {
        setWeatherGraphDateWiseData(resp.data.payload);
      }
    } catch (error) {
      console.log("handleSubmit", error);
    }
  };
  useEffect(() => {
    getReportLineChartAPI();
    getReportLineChartAPI1();
  }, [multiAxisWeatherStartDate, multiAxisWeatherEndDate, selectTimeRange]);

  const getReportLineChartAPI = async () => {
    const params = {
      company: param.companyId,
      plant: param.id,
      tag_id: [tagId("gti")],
      interval: Number(selectTimeRange),
      start_date: `${multiAxisWeatherStartDate} 00:00:00`,
      end_date: `${multiAxisWeatherEndDate} 23:59:59`,
    };

    try {
      const resp = await getReportLineChart(params);
      if (resp.status == 200 || resp.status == 201) {
        setLinechartData(resp.data.payload);
      }
    } catch (error) {
      setLinechartData([]);
      console.log("errror", error);
    }
  };

  const getReportLineChartAPI1 = async () => {
    const params = {
      company: param.companyId,
      plant: param.id,
      tag_id: [tagId("activePower")],
      interval: Number(selectTimeRange),
      start_date: `${multiAxisWeatherStartDate} 00:00:00`,
      end_date: `${multiAxisWeatherEndDate} 23:59:59`,
    };

    try {
      const resp = await getReportLineChart(params);
      if (resp.status == 200 || resp.status == 201) {
        setLinechartData1(resp.data.payload);
      }
    } catch (error) {
      setLinechartData1([]);
      console.log("errror", error);
    }
  };

  const handleWeatherGraphData = async () => {
    const params = {
      plant_id: param.id,
      gti_tag: tagId("gti"),
      ghi_tag: tagId("ghi"),
      wind_speed_tag: tagId("windSpeed"),
      ambient_temperature_tag: tagId("ambientTemp"),
      module_temperature_tag: tagId("moduleTemp"),
      weather_graph: weatherValue,
      time_period: weatherTime,
    };
    try {
      setIsLoading(true);
      const resp = await getPlantProcessDashboardWeatherGraphData(params);
      if (resp.status == 200 || resp.status == 201) {
        setWeatherGraphData(resp.data.payload);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("handleSubmit", error);
    }
  };

  useEffect(() => {
    if (inverterStartDate && inverterEndDate) {
      handleInverterBarChartDateWise();
    }
  }, [inverterStartDate, inverterEndDate]);

  useEffect(() => {
    handleInverterData();
  }, [inverterTime]);

  const handleInverterBarChartDateWise = async () => {
    const params = {
      plant_id: param.id,
      tag_ids: tagIds("inverterTags"),
      start_date: `${inverterStartDate} 00:00:00`,
      end_date: `${inverterEndDate} 23:59:59`,
    };
    try {
      const resp = await getHikemmREPlantDashboardDateWiseInverter(params);
      if (resp.status == 200 || resp.status == 201) {
        setInverterDateWiseData(resp.data.payload);
      }
    } catch (error) {
      console.log("handleSubmit", error);
    }
  };

  const handleInverterData = async () => {
    const params = {
      plant_id: param.id,
      tag_ids: tagIds("inverterTags"),
      time_period: inverterTime,
    };
    try {
      setIsLoading(true);
      const resp = await getHikemmREPlantDashboardInverter(params);
      if (resp.status == 200 || resp.status == 201) {
        setIsLoading(false);
        setInverterData(resp.data.payload);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("handleSubmit", error);
    }
  };

  useEffect(() => {
    if (costStartDate && costEndDate) {
      handleCostDataDateWise();
    }
  }, [costStartDate, costEndDate]);

  useEffect(() => {
    handleCostData();
  }, [costTime]);

  const handleCostDataDateWise = async () => {
    const params = {
      plant_id: param.id,
      cost_saving_tag: tagId("costSaving"),
      start_date: `${costStartDate} 00:00:00`,
      end_date: `${costEndDate} 23:59:59`,
    };
    try {
      setIsLoading(true);
      const resp = await getPlantProcessDashboardCostSavingData(params);
      setCostDateWiseData(resp.data.payload);
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log("handlesubmit", error);
    }
  };

  const handleCostData = async () => {
    const params = {
      plant_id: param.id,
      cost_saving_tag: tagId("costSaving"),
      time_period: costTime,
    };
    try {
      setIsLoading(true);
      const resp = await getPlantProcessDashboardCostSavingData(params);
      setCostData(resp.data.payload);
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log("handlesubmit", error);
    }
  };

  useEffect(() => {
    if (co2StartDate && co2EndDate) {
      handleCo2DataDateWise();
    }
  }, [co2StartDate, co2EndDate]);

  useEffect(() => {
    handleCo2Data();
  }, [co2Time]);

  const handleCo2DataDateWise = async () => {
    const params = {
      plant_id: param.id,
      co2_tag: tagId("co2"),
      start_date: `${co2StartDate} 00:00:00`,
      end_date: `${co2EndDate} 23:59:59`,
    };
    try {
      const resp = await getPlantProcessDashboardCo2Data(params);
      setCo2DateWiseData(resp.data.payload);
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  const handleCo2Data = async () => {
    const params = {
      plant_id: param.id,
      co2_tag: tagId("co2"),
      time_period: co2Time,
    };
    try {
      const resp = await getPlantProcessDashboardCo2Data(params);
      setCo2Data(resp.data.payload);
    } catch (error) {
      console.log("handlesubmit", error);
    }
  };

  const navigate = useNavigate();
  return (
    <>
      <div className="Bpcl-page-wrapper">
        {topics.length ? (
          <OverViewMachineMqttData
            topics={topics}
            tagListDataGroupAndList={tagListDataGroupAndList}
            setMqttTagPreviousvalue={setMqttTagPreviousvalue}
            mqttTagPreviousvalue={mqttTagPreviousvalue}
            setSliderRealTimeTagData={setSliderRealTimeTagData}
            mqttTagData={mqttTagData}
            setMqttTagData={setMqttTagData}
          />
        ) : null}
        <BPCLGeneration
          generationData={generationData}
          generationDateWiseData={generationDateWiseData}
          generationTime={generationTime}
          generationValue={generationValue}
          handleDateGenerationTime={handleDateGenerationTime}
          handleDateGenerationValue={handleDateGenerationValue}
          generationBoxData={generationBoxData}
          setMqttTagPreviousvalue={setMqttTagPreviousvalue}
          mqttTagPreviousvalue={mqttTagPreviousvalue}
          tagStatus1={tagStatus}
          sliderRealTimeTagData={sliderRealTimeTagData}
          weatherGraphData={realTimeData}
          mergedArray={mergedArray}
          generationStartDate={generationStartDate}
          generationEndDate={generationEndDate}
          setGenerationStartDate={setGenerationStartDate}
          setGenerationEndDate={setGenerationEndDate}
          acValue={acValue}
          DCValues={DCValues}
          generationCurrentData={generationCurrentData}
       
        />
        <BPCLAvailability
          plantPeakData={plantPeakData}
          plantPeakDateWiseData={plantPeakDateWiseData}
          handleDateRangeChange={handleDateRangeChange}
          dateRange={dateRange}
          setMqttTagPreviousvalue={setMqttTagPreviousvalue}
          mqttTagPreviousvalue={mqttTagPreviousvalue}
          tagStatus1={tagStatus}
          sliderRealTimeTagData={sliderRealTimeTagData}
          weatherGraphData={availabilityPiechart}
          tagValue={tagValue}
          tagValue1={tagValue1}
          tagValue2={tagValue2}
          tagValue3={tagValue3}
          availabilityStartDate={availabilityStartDate}
          setAvailabilityStartDate={setAvailabilityStartDate}
          availabilityEndDate={availabilityEndDate}
          setAvailabilityEndDate={setAvailabilityEndDate}
          weatherGraphDataPR={realTimeData}
          mergedArray={mergedArray}
          generationCurrentData={generationCurrentData}
         
        />

        <BPCLWeathers
          handleDateWeatherTime={handleDateWeatherTime}
          handleDateWeatherValue={handleDateWeatherValue}
          weatherTime={weatherTime}
          weatherValue={weatherValue}
          weatherGraphData={weatherGraphData}
          weatherGraphDateWiseData={weatherGraphDateWiseData}
          sliderRealTimeTagData={sliderRealTimeTagData}
          realTimeData={weatherRealTime}
          realWeatherData={weatherRealData}
          mergedArray={mergedArray}
          weatherStartDate={weatherStartDate}
          weatherEndDate={weatherEndDate}
          setWeatherStartDate={setWeatherStartDate}
          setWeatherEndDate={setWeatherEndDate}
          linechartData1={linechartData1 ? linechartData1 : ""}
          linechartData={linechartData ? linechartData : ""}
          multiAxisWeatherStartDate={multiAxisWeatherStartDate}
          multiAxisWeatherEndDate={multiAxisWeatherEndDate}
          setMultiAxisWeatherStartDate={setMultiAxisWeatherStartDate}
          setMultiAxisWeatherEndDate={setMultiAxisWeatherEndDate}
          setSelectTimeRange={setSelectTimeRange}
          selectTimeRange={selectTimeRange}
        />

        <BPCLInverters
          handleDateInverterTime={handleDateInverterTime}
          inverterTime={inverterTime}
          inverterData={inverterData}
          inverterDateWiseData={inverterDateWiseData}
          setMqttTagPreviousvalue={setMqttTagPreviousvalue}
          mqttTagPreviousvalue={mqttTagPreviousvalue}
          tagStatus1={tagStatus}
          sliderRealTimeTagData={sliderRealTimeTagData}
          weatherGraphData={inverterRealTimeData}
          mergedArray={mergedArray}
          inverterStartDate={inverterStartDate}
          setInverterStartDate={setInverterStartDate}
          inverterEndDate={inverterEndDate}
          setInverterEndDate={setInverterEndDate}
        />

        <BPCLCost
          costData={costData}
          costDateWiseData={costDateWiseData}
          handleDateCostTime={handleDateCostTime}
          costTime={costTime}
          costStartDate={costStartDate}
          costEndDate={costEndDate}
          setCostStartDate={setCostStartDate}
          setCostEndDate={setCostEndDate}
          handleDateCo2Time={handleDateCo2Time}
          co2Time={co2Time}
          co2Data={co2Data}
          co2DateWiseData={co2DateWiseData}
          co2StartDate={co2StartDate}
          co2EndDate={co2EndDate}
          setCo2StartDate={setCo2StartDate}
          setCo2EndDate={setCo2EndDate}
        />
        {/* <Grid container spacing={1} className="deshbord_BPCL sticky-container">
          <Grid item xs={12} sm={6} md={3}>
            <div
              className="card_weather1"
              onClick={() =>
                navigate(
                  `/energy_trends/company/${param.companyId}/plant/${param.id}`
                )
              }
            >
              <Typography variant="h5" className="deshbord_bpcl">
                ENERGY TRENDS
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <div className="card_weather1">
              <Typography
                variant="h5"
                className="deshbord_bpcl"
                onClick={() =>
                  navigate(
                    `/inverters/company/${param.companyId}/plant/${param.id}`
                  )
                }
              >
                INVERTERS
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <div
              className="card_weather1"
              onClick={() =>
                navigate(
                  `/reports/company/${param.companyId}/plant/${param.id}`
                )
              }
            >
              <Typography variant="h5" className="deshbord_bpcl">
                REPORTS
              </Typography>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            onClick={() =>
              navigate(
                `/bpcl-analytics/company/${param.companyId}/plant/${param.id}`
              )
            }
          >
            <div className="card_weather1">
              <Typography variant="h5" className="deshbord_bpcl">
                ANALYTICS
              </Typography>
            </div>
          </Grid>
        </Grid> */}
      </div>
      <div>
        <Grid container className="sticky-container" spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <button
              className="bpcl-pro-dashboard-btns"
              onClick={() =>
                navigate(
                  `/energy_trends/company/${param.companyId}/plant/${param.id}`
                )
              }
            >
              ENERGY TRENDS
            </button>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <button
              className="bpcl-pro-dashboard-btns"
              onClick={() =>
                navigate(
                  `/inverters/company/${param.companyId}/plant/${param.id}`
                )
              }
            >
              INVERTERS
            </button>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <button
              className="bpcl-pro-dashboard-btns"
              onClick={() =>
                navigate(
                  `/reports/company/${param.companyId}/plant/${param.id}`
                )
              }
            >
              REPORTS
            </button>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <button
              className="bpcl-pro-dashboard-btns"
              onClick={() =>
                navigate(
                  `/bpcl-analytics/company/${param.companyId}/plant/${param.id}`
                )
              }
            >
              ANALYTICS
            </button>
          </Grid>
        </Grid>
      </div>
      {isLoading && <Loader />}
    </>
  );
};
export default BPCLProcessDashboard;
